import { render, staticRenderFns } from "./CustomerCount.vue?vue&type=template&id=01ecb5a9&"
import script from "./CustomerCount.vue?vue&type=script&lang=ts&"
export * from "./CustomerCount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports